(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  let announcementObserver;

  function initAnnouncement(container = document) {
    const bar = container.querySelector('[data-announcement]');
    const setHeight = (h) => document.documentElement.style.setProperty('--announcement-height', h);

    if (!bar) {
      if (container === document) setHeight('0px');
      return;
    }

    const key = `announcement_${bar.dataset.id}`;
    const safeSessionStorage = {
      getItem(key) {
        try {
          return sessionStorage.getItem(key);
        } catch (e) {
          return null;
        }
      },
      setItem(key, value) {
        try {
          sessionStorage.setItem(key, value);
        } catch (e) {}
      },
    };

    if (!window.Shopify?.designMode && safeSessionStorage.getItem(key) === 'closed') {
      bar.classList.add('is-hidden');
      setHeight('0px');
      return;
    }

    setHeight(`${bar.clientHeight}px`);

    if (announcementObserver) announcementObserver.disconnect();
    announcementObserver = new ResizeObserver(() => setHeight(`${bar.clientHeight}px`));
    announcementObserver.observe(bar);

    bar.querySelector('.announcement-bar__close').addEventListener('click', () => {
      safeSessionStorage.setItem(key, 'closed');
      bar.classList.add('is-hidden');
      setHeight('0px');
      announcementObserver.disconnect();
    });
  }

  initAnnouncement();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-announcement]')) initAnnouncement(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.querySelector('[data-announcement]')) {
      if (announcementObserver) announcementObserver.disconnect();
      announcementObserver = null;
      document.documentElement.style.setProperty('--announcement-height', '0px');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
